var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaybackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playback"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.896 7.09596V19.4355C8.89609 19.6714 8.95914 19.9029 9.0786 20.1062C9.19805 20.3094 9.36957 20.4768 9.57537 20.5912C9.78116 20.7056 10.0137 20.7627 10.249 20.7566C10.4842 20.7506 10.7135 20.6815 10.9132 20.5567L20.7616 14.3869C20.9513 14.268 21.1078 14.1028 21.2162 13.9067C21.3246 13.7105 21.3815 13.49 21.3815 13.2657C21.3815 13.0415 21.3246 12.821 21.2162 12.6248C21.1078 12.4287 20.9513 12.2635 20.7616 12.1446L10.9132 5.97483C10.7135 5.84997 10.4842 5.78093 10.249 5.77485C10.0137 5.76878 9.78116 5.82589 9.57537 5.94027C9.36957 6.05465 9.19805 6.22213 9.0786 6.42534C8.95914 6.62855 8.89609 6.8601 8.896 7.09596ZM11.534 9.47926L17.5749 13.2657L11.534 17.0505V9.47926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5 0C6.04385 0 0 6.04385 0 13.5C0 20.9562 6.04385 27 13.5 27C20.9562 27 27 20.9562 27 13.5C27 6.04385 20.9562 0 13.5 0ZM13.5 2.07692C16.5296 2.07692 19.4351 3.28042 21.5773 5.42267C23.7196 7.56491 24.9231 10.4704 24.9231 13.5C24.9231 16.5296 23.7196 19.4351 21.5773 21.5773C19.4351 23.7196 16.5296 24.9231 13.5 24.9231C10.4704 24.9231 7.56491 23.7196 5.42267 21.5773C3.28042 19.4351 2.07692 16.5296 2.07692 13.5C2.07692 10.4704 3.28042 7.56491 5.42267 5.42267C7.56491 3.28042 10.4704 2.07692 13.5 2.07692Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackIcon);
export default __webpack_public_path__ + "static/media/playback-icon.3ae7ae63e23939c5a99b2eaea0bafcfe.svg";
export { ForwardRef as ReactComponent };